import type { Note, Person } from "@/services/api";
import type { NotesTableRowData } from "../../model";

export const buildNotesTableDataSource = ({
  notes,
  persons,
}: {
  notes: Note[];
  persons: Person[];
}): NotesTableRowData[] => {
  return notes.map((note) => {
    return { ...note, person: persons.find((person) => person.id === note.personId) as Person };
  });
};
